import React from 'react';
import type { User } from '../types';

interface ConversationListProps {
  conversations: { partner: User, lastMessage: string, timestamp: string }[];
  activePartnerHandle: string | null;
  onSelectConversation: (user: User) => void;
}

const ConversationList: React.FC<ConversationListProps> = ({ conversations, activePartnerHandle, onSelectConversation }) => {
    
    const sortedConversations = [...conversations].sort((a, b) => b.timestamp.localeCompare(a.timestamp));

  return (
    <div className="h-full flex flex-col">
      <ul className="flex-grow overflow-y-auto space-y-2 pr-2">
        {sortedConversations.length > 0 ? sortedConversations.map(({ partner, lastMessage }) => (
          <li key={partner.handle}>
            <button
              onClick={() => onSelectConversation(partner)}
              className={`w-full text-left p-3 rounded-lg flex items-center space-x-3 transition-colors ${
                activePartnerHandle === partner.handle
                  ? 'bg-brand-orange/20'
                  : 'hover:bg-gray-700/50'
              }`}
            >
              <img src={partner.avatarUrl} alt={partner.name} className="h-12 w-12 rounded-full" />
              <div className="flex-1 overflow-hidden">
                <p className="font-semibold text-white truncate">{partner.name}</p>
                <p className="text-sm text-brand-muted truncate">{lastMessage}</p>
              </div>
            </button>
          </li>
        )) : (
          <div className="text-center text-brand-muted pt-10">
            <p className="font-semibold">No conversations yet</p>
            <p className="text-sm mt-1">Start a new message to begin chatting.</p>
          </div>
        )}
      </ul>
    </div>
  );
};

export default ConversationList;